import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import "./success.css";
import { Smscancelledbooking } from "../../Redux/Actions";
import { useDispatch } from "react-redux";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
function Cancel() {


  const { idSlug } = useParams()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(Smscancelledbooking(idSlug))
  }, [idSlug])


  return (
    <>
      <Header/>
      <div className="success">
        <h1>Alert Booking has been Cancelled !</h1>
      </div>
      <Footer/>
    </>
  );
}

export default {
  component: Cancel,
};